import { SearchResultEntry } from "./registry"

export function SearchResultRow<Data extends object>({
    entry,
    variant = "compact",
    onAfterSelect,
}: {
    entry: SearchResultEntry<Data>
    variant?: "compact" | "full"
    onAfterSelect: () => void
}) {
    const Component =
        variant === "full"
            ? (entry.plugin.FullPanelResultComponent ?? entry.plugin.Component)
            : entry.plugin.Component
    return <Component {...entry.data} onAfterSelect={onAfterSelect} />
}
